import { CommonButton } from '@shared/ui';
import { AuthForm } from '@src/modules/Authentication/AuthFrom';
import ButtonLink from '@src/modules/Authentication/ButtonLink/index.ts';
import { Captcha } from '@src/modules/Authentication/Captcha';
import CustomInput from '@src/modules/Authentication/CustomInput';
import { ModalError } from '@src/modules/Authentication/frames/modal-error';
import * as st from './styles.module.scss';

interface Props {
  model: any;
  type: string;
}

export const ResetPhoneStep = ({ model, type }: Props) => {
  const errorMessage: string =
    model.phoneNumberErrors?.phonenumber?.message || model.phoneNumberErrors?.root?.message;
  return (
    <AuthForm
      onSubmit={model.handleSubmit((data: any) => model.checkedPhone(data.phonenumber, type))}
    >
      <CustomInput
        tabindex={0}
        type="phonenumber"
        label="Телефон"
        name="phonenumber"
        control={model.controlPhoneNumber}
        error={model.phoneNumberErrors?.phonenumber}
        disabled={model.isLoading}
        variant="outline"
      />

      <ButtonLink
        className={st.buttonLink}
        disabled={model.isLoading}
        handler={model.openEmailForm}
      >
        Восстановить через почту
      </ButtonLink>

      <Captcha tabIndex={0} onChange={model.onCaptchaChange} className={st.captcha} />

      {errorMessage ? (
        <ModalError error={errorMessage} />
      ) : (
        <div className={st.wrapper}>
          <CommonButton tabIndex={0} type="submit" disabled={!model.isCaptchaVerified}>
            Запросить код
          </CommonButton>
        </div>
      )}
    </AuthForm>
  );
};
